<div class="ipm-dpp" role="dialog" aria-modal="true" aria-labelledby="ipm-dpp-title">
    <!-- top-right corner of the whole popup (the panels stack on mobile) -->
    <button type="button" class="ipm-dpp-close" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
    </button>
    <!-- left: fireworks + offer callout -->
    <div class="ipm-dpp-left">
        <canvas class="ipm-dpp-canvas" #fireworksCanvas aria-hidden="true"></canvas>
        <div class="ipm-dpp-veil"></div>
        <div class="ipm-dpp-watermark" aria-hidden="true">₹</div>
        <div class="ipm-dpp-left-content">
            <div class="ipm-dpp-tag1">Start Selling</div>
            <div class="ipm-dpp-tag2">with Pro</div>
            <div class="ipm-dpp-pct">{{saleOff}}%</div>
            <div class="ipm-dpp-off">Off</div>
            <div class="ipm-dpp-rule"></div>
            <div class="ipm-dpp-left-price">{{proPlanSalePrice | currency : 'INR' : 'symbol' : '1.0-0'}}</div>
            <div class="ipm-dpp-left-was">{{proPlanPrice | currency : 'INR' : 'symbol' : '1.0-0'}}</div>
            <div class="ipm-dpp-cycle">Billed annually</div>
        </div>
    </div>

    <!-- right: plan, price, countdown, benefits, CTA -->
    <div class="ipm-dpp-right">
        <div class="ipm-dpp-plan-row">
            <h2 class="ipm-dpp-plan-name" id="ipm-dpp-title">Pro Plan</h2>
            <span class="ipm-dpp-plan-pill">{{saleOff}}% OFF</span>
        </div>

        <div class="ipm-dpp-price-row">
            <span class="ipm-dpp-price">{{proPlanSalePrice | currency : 'INR' : 'symbol' : '1.0-0'}}</span>
            <span class="ipm-dpp-price-old">{{proPlanPrice | currency : 'INR' : 'symbol' : '1.0-0'}}</span>
            <span class="ipm-dpp-price-cycle">/ year</span>
        </div>

        <div class="ipm-dpp-countdown" *ngIf="countdown">
            <span class="ipm-dpp-cd-label">⏳ Offer ends in</span>
            <span class="ipm-dpp-cd-nums">
                {{countdown.d}}<span class="ipm-dpp-cd-sep">d</span>
                {{countdown.h}}<span class="ipm-dpp-cd-sep">h</span>
                {{countdown.m}}<span class="ipm-dpp-cd-sep">m</span>
                {{countdown.s}}<span class="ipm-dpp-cd-sep">s</span>
            </span>
        </div>

        <ul class="ipm-dpp-benefits">
            <li class="ipm-dpp-benefit" *ngFor="let benefit of benefits">
                <span class="ipm-dpp-check"><i class="pi pi-check"></i></span>
                <span>{{benefit}}</span>
            </li>
        </ul>

        <button type="button" class="ipm-dpp-cta" (click)="onClaim()">
            🎉 {{ isUpgrade ? 'Upgrade to Pro Annual' : 'Claim Diwali Offer' }} →
        </button>

        <div class="ipm-dpp-foot">
            <div class="ipm-dpp-foot-links">
                <button type="button" class="ipm-dpp-dismiss" (click)="close()">Maybe Later</button>
                <button type="button" class="ipm-dpp-compare" (click)="compare.emit()">Compare plans <i class="pi pi-arrow-right"></i></button>
            </div>
            <div class="ipm-dpp-trust">Cancel anytime · Secure Payment · Instant Access</div>
        </div>
    </div>
</div>
